// extracted by mini-css-extract-plugin
export default {"validateCardDialog":"validateCardDialog--SPQDA"};